import { useTranslation } from "react-i18next";

import { useOrderStore } from "../../stores/use-order-store";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import ReceiptScreen from "./receipt-screen";

export default function ReceiptDialog() {
  const { t } = useTranslation("common");
  const {
    receiptDialogOpen,
    setReceiptDialogOpen,
    selectedReceipt,
    setSelectedReceipt,
  } = useOrderStore();
  const handleDialog = (open: boolean) => {
    setReceiptDialogOpen(open);
    if (open === false) {
      setSelectedReceipt({});
    }
  };
  return (
    <Dialog open={receiptDialogOpen} onOpenChange={setReceiptDialogOpen}>
      <DialogContent className="max-w-2xl w-full @container">
        <DialogHeader>
          <DialogTitle>{t("Ticket.receipt")}</DialogTitle>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          {selectedReceipt?.receipt && (
            <ReceiptScreen
              receipt={selectedReceipt.receipt}
              showUnfinalizeButton={selectedReceipt.showCredit}
              onClose={() => {
                handleDialog(false);
              }}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
